import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import user from './user'
import users from './users'
import notifications from './notifications'
import organization from './organization'
import plans from './plans'
import documents from './documents'
import header from './header'
import reports from './reports'
import home from './home'
import nippo from './nippo'

export default combineReducers({
  form: formReducer,
  user,
  users,
  notifications,
  organization,
  plans,
  documents,
  header,
  reports,
  home,
  nippo
})



// WEBPACK FOOTER //
// ./src/reducers/index.js